import { API } from '~/api/api';

interface Context {
  shop_id: string;
}

async function Coupons(context: Context) {
  try {
    const coupons = await API.get(`/coupons`, {
      // список купонов на скидку
      params: {
        status: 'active',
        shop_id: context.shop_id,
      },
    });
    return coupons?.data?.list || [];
  } catch (error) {
    return [];
  }
}

async function CouponsBottom(context: Context) {
  try {
    const bottom = await API.get(`/coupons/similar/${context.shop_id}/bottom`);
    return bottom?.data;
  } catch (e) {
    return [];
  }
}

async function CouponsBest(context: Context) {
  try {
    const best = await API.get(`/coupons/similar/${context.shop_id}/best`);
    return await best?.data;
  } catch (e) {
    return [];
  }
}

async function CouponsShopID(context: Context) {
  try {
    const shops = await API.get(`/shops/${context.shop_id}`);
    return shops?.data;
  } catch (e) {
    return [];
  }
}

async function CouponsPromocodesCategory(context: Context) {
  try {
    const categories = await API.get(
      `/shops/${context.shop_id}/coupons/categories`
    );
    return (
      categories?.data.map((el: { slug: string }) => ({
        ...el,
        slug: `promokody-${el.slug}`,
      })) || []
    );
  } catch (e) {
    return [];
  }
}

export default async function initShopPromocodes(context: Context) {
  const [promocodes, similar, promotions, shopData, promocodesCategory] =
    await Promise.all([
      Coupons(context),
      // похожие скидки/акции других магазинов
      CouponsBottom(context),
      // список лучших акций
      CouponsBest(context),
      // информация об магазине
      CouponsShopID(context),
      // список категорий, в которые попадает товар из данного магазина
      CouponsPromocodesCategory(context),
    ]);

  return {
    promocodes,
    similar,
    promotions,
    shopData,
    promocodesCategory,
  };
}
